import { getPasswordRequirements } from '@phoenix/helpers/form-helper';

export default {
  props: {
    redirectUrl: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      formConfigName: 'resetPassword',
      values: {},
      fields: {
        password: {
          id: 'password',
          name: 'password',
          type: 'password',
          label: this.$t('Form.password'),
          required: true,
          value: null,
          requirements: getPasswordRequirements(),
        },
        passwordConfirmation: {
          id: 'password_confirmation',
          name: 'password_confirmation',
          type: 'password',
          label: this.$t('Form.password_confirmation'),
          required: true,
          value: null,
        },
        resetPasswordToken: {
          id: 'resetPasswordToken',
          name: 'resetPasswordToken',
          type: 'hidden',
          value: new URLSearchParams(window.location.search).get('token'),
          required: true,
        },
      },
      blacklistedFieldsFromPrefillFromQuery: ['password', 'passwordConfirmation'],
    };
  },

  computed: {
    formAction() {
      return window.route('api.customer.password.reset');
    },
  },
};
